import React, {useEffect, useState} from 'react';
import useApi from "../../../utils/useApi";
import {useParams, useSearchParams} from "react-router-dom";
import ClientDocumentList from "../ClientDocumentList/ClientDocumentList";
import {useTaxYear} from "../../../contexts/TaxYearContext";


const AdminClientDocuments = ({user, handleShowHeader, handleShowSettingsHeader}) => {
    const {user_id} = useParams();
    const { taxYear, updateTaxYear } = useTaxYear();
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const { getClientDocuments, getDocumentStatus } = useApi();
    const [client, setClient] = useState(null);
    const [documentStatus, setDocumentStatus] = useState(null);
    const [currentDocument, setCurrentDocument] = useState(null);
    const [clientDocuments, setClientDocuments] = useState([]);
    const [availableYears, setAvailableYears] = useState([]);


    useEffect(() => {
        handleShowHeader(true);
        handleShowSettingsHeader(false);
        initializeDocumentStatus();
        initializeDocuments();
    }, [user_id, taxYear]);

    const initializeDocuments = async () => {
        setLoading(true);
        const data = {
            year: taxYear,
        }
        const results = await getClientDocuments(user_id, data);
        setClientDocuments(results.documents);
        setClient(results.user);
        setAvailableYears(results.availableYears);
        setLoading(false);
    }

    const initializeDocumentStatus = async () => {
        const data = {
            year: taxYear,
        }
        const response = await getDocumentStatus(user_id, data);
        setDocumentStatus(response);
        setCurrentDocument(response.currentDocument);
    }

    const handleSelectYear = (year) => {
        console.log(year)
    }


    return (
        <>
            <ClientDocumentList client={client} documents={clientDocuments} loading={loading} availableYears={availableYears} selectedYear={taxYear} onSelectYear={handleSelectYear} />
        </>
    );
}


export default AdminClientDocuments;
